<template>
  <flow-canvas
    :search="search"
    v-model="intents"
    v-if="flow && intents && showFlow"
    :flow="flow"
    @onFlowEdit="updateFlow"
    @onMoveNode="moveNode"
    @updateNode="updateNode(false, $event)"
    @updateNodeSilence="updateNode(true, $event)"
  ></flow-canvas>
</template>

<script>
import { cloneDeep } from 'lodash'
import api from '@/api'
import { mapGetters } from 'vuex'
import FlowCanvas from './FlowCanvas'
import flowMixin from '@/mixins/flowMixin'
export default {
  mixins: [flowMixin],
  props: ['value', 'search'],
  data() {
    return {
      // flow: null,
      intents: null,
      showFlow: false
    }
  },
  components: {
    FlowCanvas
  },
  computed: {
    ...mapGetters({
      flow: 'getFlowId'
    })
  },
  async mounted() {
    // this.flow = this.value
    this.showFlow = false
    if (this.flow) {
      try {
        this.$store.dispatch('loading')
        var intents = await this.getFlowAllIntents()
        this.$store.dispatch('loading')
        if (intents) {
          this.intents = this.convertJsonToObject(intents)
        }

        this.$emit('loadIntent', this.intents)
        this.showFlow = true
      } catch (error) {
        console.error(error)
        this.showFlow = false
      }
    }
  },
  methods: {
    updateNode(isSilence, { payload, oncomplete }) {
      var vm = this
      vm.$store.dispatch('loading')

      return new Promise((resolve, reject) => {
        if (payload === undefined) {
          if (oncomplete) {
            oncomplete(null)
          }
          resolve()
        }
        var data = cloneDeep(payload)
        data.x = parseInt(data.x)
        data.y = parseInt(data.y)
        data.question = data.question ? data.question : ''
        if (typeof data.connected_intents != 'string')
          data.connected_intents = JSON.stringify(data.connected_intents)
        if (typeof data.answer != 'string') data.answer = JSON.stringify(data.answer)
        data.quick_reply = data.quick_reply ? data.quick_reply : ''

        api.editNode(data, function(error, response) {
          if (error) {
            console.error('updateNode:', error)
            if (!isSilence) {
              vm.flash('Save Unsuccessful: ' + error.message, 'error', {
                timeout: 3000
              })
            }
            vm.$store.dispatch('loading')
            reject(error)
          }

          if (response.responsecode == 200) {
            if (!isSilence) {
              vm.flash('Save Successful', 'success', {
                timeout: 3000
              })
            }
            vm.$store.dispatch('loading')
            var intentIndex = vm.intents.findIndex(el => {
              return el.id == payload.id
            })
            if (response.data && response.data.length > 0) {
              var intent = vm.convertSingleNode(response.data[0])

              if (intentIndex != -1) {
                vm.$set(vm.intents, intentIndex, intent)
              } else {
                vm.intents.push(intent)
              }
              vm.$nextTick(() => {
                if (oncomplete) {
                  oncomplete(intent)
                }
              })
            }
            resolve()
          } else {
            reject(response.responsecode)
          }
        })
        // } else {
        //   if (!isSilence) {
        //     vm.flash('Save Unsuccessful ', 'error', {
        //       timeout: 3000
        //     })
        //   }
        //   reject()
        // }
      })
    },
    moveNode(payload) {
      var vm = this

      return new Promise((resolve, reject) => {
        var intent = this.intents.find(el => {
          return el.id == payload.id
        })
        // console.log(intent)
        if (intent) {
          var data = Object.assign({}, intent)
          data.x = parseInt(payload.x)
          data.y = parseInt(payload.y)
          data.question = data.question ? data.question : ''
          data.connected_intents = JSON.stringify(data.connected_intents)
          data.answer = JSON.stringify(data.answer)
          data.quick_reply = data.quick_reply ? data.quick_reply : ''
          api.editNode(data, function(error, response) {
            if (error) {
              console.error(error)
              vm.flash('Save Unsuccessful: ' + error.message, 'error', {
                timeout: 3000
              })

              reject()
            }

            if (response.responsecode == 200) {
              vm.flash('Save Successful', 'success', {
                timeout: 3000
              })
            } else {
              throw new Error(response.responsecode)
            }
            resolve()
          })
        } else {
          reject()
        }
      })
    },
    updateFlow(payload) {
      var vm = this
      // vm.$store.dispatch('loading')
      return new Promise((resolve, reject) => {
        var data = {
          ...this.flow,
          x: parseInt(payload.x),
          y: parseInt(payload.y),
          zoom: payload.zoom
        }
        api.editFlow(data, function(error, response) {
          if (error) {
            console.error(error)
            vm.flash('Save Unsuccessful: ' + error.message, 'error', {
              timeout: 3000
            })
            // vm.$store.dispatch('loading')
            reject()
          }
          resolve()
          // vm.$store.dispatch('loading')
          // vm.flash('Save Successful', 'success', {
          //   timeout: 3000
          // })
        })
      })
    },
    convertJsonToObject(intents) {
      return intents.map(intent => {
        return this.convertSingleNode(intent)
      })
    },

    getFlowAllIntents() {
      return new Promise((resolve, reject) => {
        var data = { flowid: this.flow.id }
        api.getFlowAllIntents(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/Flow.vue